export default __webpack_public_path__ + "static/media/Graphik-LightItalic.2a0f75a6.otf";